import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyStoreTranslations = wrapTranslationsSchema({
	name: 'BuyEasyStoreTranslations',
	title: 'Store Translations',
	sanityId: 'buyeasy-store',
	fields: {
		notSelected: 'not selected',
		title: 'You’re browsing for purchasing org',
		country: 'Country',
		companyCode: 'Company Code',
		purchasingOrg: 'Purchasing Org.',
	},
});
